import React from "react";
import { MainLayout } from "../components/Common/MainLayout/mainlayout";
import { AuthenticationLayout } from "../components/Common/AuthLayout/AuthenticationLayout";
import { SignUpContent } from "../components/Authentication/SignUpContent";
import { SignInContent } from "../components/Authentication/SignInContent";
import { LockScreenContent } from "../components/Authentication/LockScreenContent";
import { LogOutContent } from "../components/Authentication/LogOutContent";
import { PasswordChangeContent } from "../components/Authentication/PasswordChangeContent";
import { PasswordResetContent } from "../components/Authentication/PasswordResetContent";
import { SuccessMsgContent } from "../components/Authentication/SuccessMsgContent";
import { ErrorPageContent } from "../components/Authentication/ErrorPageContent";
import { ErrorPageContentOne } from "../components/Authentication/ErrorPageContentOne";
import { TwoStepAuthContent } from "../components/Authentication/TwoStepAuthContent";
import { OfflinePageContent } from "../components/Authentication/OfflinePageContent";
import AuthProtected from "./AuthProtected";
import PublicRoute from "./PublicRoute";
import { ProfilePage } from "../pages/profilePage";
import { ChangePassword } from "../pages/ChangePassword";
import { DashboardPage } from "../pages/dashboardPage";
import { Navigate } from "react-router-dom";
import { BlogsAdd } from "../pages/BlogsAdd";
import { BlogsManage } from "../pages/BlogsManage";
import { PageGroup } from "../pages/PageGroup";
import { PageMaster } from "../pages/PageMaster";
import { CreateRoles } from "../pages/CreateRoles";
import { ManageAccessPage } from "../pages/ManageAccess";

import { NewUser } from "../pages/NewUser";
import { NewUserView } from "../pages/NewUserView";
import { NewUserUpdate } from "../pages/NewUserUpdate";
import { UserDashboardPage } from "../pages/UserDashboardPage";
import { AffiliationsMaster } from "../pages/AffiliationsMaster";
import { TestimonialsMaster } from "../pages/TestimonialsMaster";
import { AnnouncementBarSettings } from "../pages/AnnouncementBarSettings";
import { AIModelMasters } from "../pages/AIModelMasters";
import { AIModelSetups } from "../pages/AIModelSetups";
import { AIPromptMasters } from "../pages/AIPromptMasters";
import { ContentCategories } from "../pages/ContentCategories";
import { ContentTopics } from "../pages/ContentTopics";
import { ContentSectionsManage } from "../pages/ContentSectionsManage";
import { ContentSectionsAdd } from "../pages/ContentSectionsAdd";
import { ContentsManage } from "../pages/ContentsManage";
import { ContentsAdd } from "../pages/ContentsAdd";
import { SectionMapping } from "../pages/SectionMapping";
import { Advertisements } from "../pages/Advertisements";
import { HeroBanners } from "../pages/HeroBanners";
import { ManageSections } from "../pages/ManageSections";
import { ManageSubSections } from "../pages/ManageSubSections";
import { ArticlesManage } from "../pages/ArticlesManage";
import { ArticlesAdd } from "../pages/ArticlesAdd";
import { SubscribersManage } from "../pages/SubscribersManage";
import { ManageMediaLibrary } from "../pages/ManageMediaLibrary";
import { EventsManage } from "../pages/EventsManage";
import { EventsAdd } from "../pages/EventsAdd";

const routes = [
  {
    path: "/",
    element: (
      <AuthProtected>
        <MainLayout />
      </AuthProtected>
    ),
    children: [
      { path: "/", element: <Navigate to="/dashboard" replace /> },
      { path: "page-group", element: <PageGroup /> },
      { path: "page-master", element: <PageMaster /> },
      { path: "affiliations", element: <AffiliationsMaster /> },
      { path: "testimonials", element: <TestimonialsMaster /> },
      {
        path: "announcement-bar-settings",
        element: <AnnouncementBarSettings />,
      },
      { path: "ai-model-masters", element: <AIModelMasters /> },
      { path: "ai-model-setups", element: <AIModelSetups /> },
      { path: "ai-prompt-masters", element: <AIPromptMasters /> },
      {
        path: "content-categories",
        element: <ContentCategories />,
      },
      { path: "content-topics", element: <ContentTopics /> },
      { path: "content-sections", element: <ContentSectionsManage /> },
      {
        path: "content-sections",
        children: [
          { path: "add", element: <ContentSectionsAdd /> },
          { path: "update/:id", element: <ContentSectionsAdd /> },
        ],
      },
      { path: "contents", element: <ContentsManage /> },
      {
        path: "contents",
        children: [
          { path: "add", element: <ContentsAdd /> },
          { path: "update/:id", element: <ContentsAdd /> },
        ],
      },
      { path: "section-mapping", element: <SectionMapping /> },
      { path: "advertisements", element: <Advertisements /> },
      { path: "hero-banners", element: <HeroBanners /> },
      { path: "manage-sections", element: <ManageSections /> },
      { path: "manage-sub-sections", element: <ManageSubSections /> },
      { path: "articles", element: <ArticlesManage /> },
      {
        path: "articles",
        children: [
          { path: "add", element: <ArticlesAdd /> },
          { path: "update/:id", element: <ArticlesAdd /> },
        ],
      },
      { path: "events", element: <EventsManage /> },
      {
        path: "events",
        children: [
          { path: "add", element: <EventsAdd /> },
          { path: "update/:id", element: <EventsAdd /> },
        ],
      },
      { path: "manage-subscribers", element: <SubscribersManage /> },
      { path: "media-library", element: <ManageMediaLibrary /> },
      { path: "create-role", element: <CreateRoles /> },
      {
        path: "Manage-role-access/:roleId/:roleName",
        element: <ManageAccessPage />,
      },

      { path: "user", element: <NewUserView /> },

      //routing for user management
      { path: "user", element: <NewUserView /> },
      {
        path: "user",
        children: [
          { path: "add", element: <NewUser /> },
          { path: "update/:id", element: <NewUserUpdate /> },
        ],
      },
      //--------------------------

      { path: "dashboard", element: <DashboardPage /> },
      { path: "user-dashboard", element: <UserDashboardPage /> },
      { path: "my-profile", element: <ProfilePage /> },
      { path: "change-password", element: <ChangePassword /> },
      //routing for blog management
      { path: "blogs", element: <BlogsManage /> },
      {
        path: "blogs",
        children: [
          { path: "add", element: <BlogsAdd /> },
          { path: "update/:id", element: <BlogsAdd /> },
        ],
      },

      //------------------
    ],
  },
  {
    path: "/auth",
    element: (
      <PublicRoute>
        <AuthenticationLayout />
      </PublicRoute>
    ),
    children: [
      { path: "signup", element: <SignUpContent /> },
      { path: "signin", element: <SignInContent /> },
      { path: "lock-screen", element: <LockScreenContent /> },
      { path: "logout", element: <LogOutContent /> },
      { path: "password-change", element: <PasswordChangeContent /> },
      { path: "password-reset", element: <PasswordResetContent /> },
      { path: "success-message", element: <SuccessMsgContent /> },
      { path: "verification", element: <TwoStepAuthContent /> },
    ],
  },

  {
    path: "/forgot-password",
    element: (
      <PublicRoute>
        <AuthenticationLayout />
      </PublicRoute>
    ),
    children: [
      { path: "/forgot-password", element: <PasswordResetContent /> },
    ],
  },
  {
    path: "/500-error-page",
    element: <ErrorPageContentOne />,
  },
  { path: "404-error-page", element: <ErrorPageContent /> },
  {
    path: "/offline",
    element: <OfflinePageContent />,
  },
];

export default routes;
